import styled from "styled-components";
import { palette } from "styled-theme";

export const LoanApplicationDetailsTitle = styled.p`
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  text-align: center;
  color: ${palette("thankYou", 1)};
  
  margin-top: 30px;
  margin-bottom: 20px;
  padding: 0 10px;
`;